import { render, staticRenderFns } from "./dictionary-item-selector.vue?vue&type=template&id=0fe54f38&scoped=true"
import script from "./dictionary-item-selector.vue?vue&type=script&lang=js"
export * from "./dictionary-item-selector.vue?vue&type=script&lang=js"
import style0 from "./dictionary-item-selector.vue?vue&type=style&index=0&id=0fe54f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe54f38",
  null
  
)

export default component.exports